import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { LogService } from '../services/log.service';

@Component({
  selector: 'app-kiln-firing-log',
  templateUrl: './kiln-firing-log.component.html',
  styleUrls: ['./kiln-firing-log.component.scss'],
})
export class KilnFiringLogComponent implements OnChanges {
  @Input() externalId: string;
  @Input() inAdminPage: boolean;
  public logName: string = ""
  public s3LogPath: string = ""
  public urlVisible: boolean = false;
  public urlString: string = "";
  public gotFilename: boolean = false;


  constructor(
    private logService: LogService,
    private inAppBrowser: InAppBrowser,
    private alertController: AlertController,
    private toastController: ToastController,
  ) { }

  ngOnChanges() {
    this.logName = "";
    this.logService.logfiles.subscribe((logFiles) => {
      let logFilesForKiln = logFiles[this.externalId]
      if(logFilesForKiln?.length > 0) {
        this.gotFilename = true;

        let lastLog = logFilesForKiln[ logFilesForKiln.length - 1 ]
        this.logName = lastLog?.name;
        this.s3LogPath = lastLog?.s3PathName;
      }
    })

    this.logService.getLogFileNames(this.externalId).catch(() => {
      this.showMessage(`Error loading kiln logs. Pull down to refresh`, 'toast-failure')
    })
  }

  async downloadFromAdminPage() {
    this.logService.downloadLog(this.externalId, this.s3LogPath).then((response) => {
      this.urlString = JSON.stringify(response.url);

      this.inAppBrowser.create(response.url, '_system')
    }).catch((error) => {
      console.log("KilnLink Log: Error downloading file. " + JSON.stringify(error))
      this.showMessage(`Error downloading kiln log. Please try again`, 'toast-failure')
    })
  }

  async downloadWithApprovalPopup() {
    let alert = await this.alertController.create({
      header: "Download the log file?",
      message: `Please confirm you want to download the log file.`,
      buttons: [
        {
          text: 'Cancel',
          cssClass: 'primary',
          role: 'cancel'
        }, {
          text: "Download",
          cssClass: 'secondary',
          handler: (data) => {
            this.logService.downloadLog(this.externalId, this.s3LogPath).then((response) => {
              this.urlString = JSON.stringify(response.url);

              this.inAppBrowser.create(response.url, '_system')
            }).catch((error) => {
              console.log("KilnLink Log: Error downloading file. " + JSON.stringify(error))
              this.showMessage(`Error downloading kiln log. Please try again`, 'toast-failure')
            })
          }
        }
      ]
    });
    alert.present();
  }

  async download(){
    if (this.inAdminPage){
      this.downloadFromAdminPage();
    } else {
      this.downloadWithApprovalPopup()
    }
  }

  async showMessage(message, cssClass = 'toast-success') {
    let toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'top',
      cssClass: cssClass
    });

    toast.present();
  }

}
